import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Identity14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 4.75C8.2255 4.75 9.25 5.7745 9.25 7C9.25 7.67642 8.93548 8.32874 8.41421 8.75001L9 8.75001C9.9665 8.75001 10.75 9.53351 10.75 10.5V11.5H9.25V10.5C9.25 10.3619 9.13807 10.25 9 10.25L5 10.25C4.86193 10.25 4.75 10.3619 4.75 10.5V11.5H3.25V10.5C3.25 9.5335 4.0335 8.75 5.00001 8.75L5.58578 8.75C5.06451 8.32873 4.75 7.67642 4.75 7C4.75 5.7745 5.7745 4.75 7 4.75ZM7 6.25C6.60218 6.25 6.25 6.60218 6.25 7C6.25 7.39782 6.60218 7.75 7 7.75C7.39782 7.75 7.75 7.39782 7.75 7C7.75 6.60218 7.39782 6.25 7 6.25Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.725 1.25H11.5C12.1904 1.25 12.75 1.80964 12.75 2.5V12.5C12.75 13.1904 12.1904 13.75 11.5 13.75H2.5C1.80964 13.75 1.25 13.1904 1.25 12.5V2.5C1.25 1.80964 1.80964 1.25 2.5 1.25H4.275C4.39082 0.67944 4.89526 0.25 5.5 0.25H8.5C9.10474 0.25 9.60918 0.67944 9.725 1.25ZM4.275 2.75H2.75V12.25H11.25V2.75H9.725C9.60918 3.32056 9.10474 3.75 8.5 3.75H5.5C4.89526 3.75 4.39082 3.32056 4.275 2.75ZM5.75 2.25V1.75H8.25V2.25H5.75Z'
      fill='currentColor'
    />
  </Svg>
);

Identity14.displayName = 'Identity14';
export default Identity14;
